<template>
  <div style="position: relative">
    <div class="style-fullWidth">
      <div class="grid-container" style="font-size: 16px">
        <div class="item" v-if="isViewShareMode">
          <span class="title">Cấp quy trình:</span>
          <span class="font-size__small font_blued">{{ parentDeptName }}</span>
        </div>
        <div class="item">
          <span class="title">Tiêu đề:</span>
          <span class="font-size__small font_blued">{{ meetingTitle }}</span>
        </div>

        <div class="item" v-if="meetingPlace || isMeetingOnline">
          <span class="title">Địa điểm:</span>
          <span v-if="!isMeetingOnline" class="font-size__small font_blued">{{
            meetingPlaceLabel
          }}</span>
          <span
            v-else-if="!ableToJoinMeeting"
            class="font-size__small font_blued"
            >{{ meetingPlaceLabel }}</span
          >
          <el-tooltip v-else :content="'Tham gia cuộc họp'" placement="top">
            <a href="#" class="color__blue" @click.stop="joinRoom">
              {{ meetingPlaceLabel }}
              <i class="fas fa fa-sign-in font-size__small"></i>
            </a>
          </el-tooltip>
        </div>

        <div class="item">
          <div class="title">Thành phần tham dự:</div>
          <div class="font-size__small">
            - Lãnh đạo:
            <span class="font_blued"> {{ leaderNames || "-" }} </span>
          </div>
          <div v-if="chairedUnit" class="font-size__small">
            - Chủ trì: {{ chairedUnit }}
          </div>
          <div
            v-if="cooperateDeptNames && cooperateDeptNames.length"
            class="font-size__small"
          >
            - Phối hợp:
            {{ cooperateDeptNames ? cooperateDeptNames.join(", ") : "" }}
          </div>
        </div>
      </div>
      <div class="grid-container">
        <div class="item">
          <span class="title">Nội dung công việc:</span>
          <span class="font-size__small">{{ meetingContent }}</span>
        </div>
        <div class="item" v-if="otherInvolved">
          <span class="title">Ghi chú:</span>
          <span class="font-size__small">{{ otherInvolved }}</span>
        </div>
        <div class="item" v-if="vbAttachments && vbAttachments.length">
          <span class="title">File đính kèm</span>
          <br />
          <div class="jobInfoAttachment">
            <div
              v-for="vbAttachment in vbAttachments"
              v-bind:key="vbAttachment.id"
              class="file-uploaded input-none__border"
            >
              <div class="file clickable flex-row flex__between padding-0">
                <a
                  class="flex-row flex__left margin-left-10"
                  @click.stop="downloadFile(vbAttachment)"
                >
                  <file-type-image
                    :fileExtention="vbAttachment.fileExtention"
                  />
                  <el-tooltip :content="vbAttachment.fileName" placement="top">
                    <span class="" :title="vbAttachment.fileName">{{
                      vbAttachment.fileName
                    }}</span>
                  </el-tooltip>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sharedIconDiv" v-if="hcCaseMasterUser">
      <i class="cellIcon color__silver fas fa-user-circle"></i>
    </div>
  </div>
</template>

<script>
import attachmentService from "../../../services/attachmentService";
import FileTypeImage from "../../job/FileTypeImage";
import downloadService from "../../../services/downloadService";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import utils from "../../../services/utils";
import h from "../../../services/h";
import constants from "../../../constants";
import hcCaseCalendarUserViewService from "../../../services/hcCaseCalendarUserViewService";
import hcCaseMasterUserService from "../../../services/hcCaseMasterUserService";
import hcCaseCalendarService from "../../../services/hcCaseCalendarService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCfgMeetingRoomService from "../../../services/hcCfgMeetingRoomService";

export default {
  name: "fullCalendar-lichtuan-row",

  components: { FileTypeImage },
  props: [
    "meetingTitle",
    "meetingPlace",
    "chairedUnit",
    "cooperateDeptNames",
    "meetingContent",
    "otherInvolved",
    "caseMasterId",
    "hcCaseCalendarId",
    "groupFilters",
    "isViewShareMode",
    "parentDeptName",
    "hcCaseCalendarView",
  ],

  data() {
    return {
      vbAttachments: [],
      leaders: [],
      groups: [],
      leaderNames: null,
      hcCaseMasterUser: null,
      hcCfgMeetingRoom: null,
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    isMeetingOnline() {
      return (
        this.hcCaseCalendarView.status === "HOANTHANH" &&
        this.hcCaseCalendarView &&
        (this.hcCaseCalendarView.meetingType ===
          constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE ||
          this.hcCaseCalendarView.meetingType ===
            constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH)
      );
    },

    ableToJoinMeeting() {
      return this.isMeetingOnline && this.hcCaseCalendarView.hcMeetingRoomId;
    },

    id() {
      return this.hcCaseCalendarView ? this.hcCaseCalendarView.id : null;
    },

    meetingPlaceLabel() {
      return hanhChinhUtils.getMeetingPlaceLabel(
        this.hcCaseCalendarView,
        this.hcCfgMeetingRoom
      );
    },
  },

  created() {
    this.loadVbAttachments();
    this.loadHcCfgMeetingRoom();
    this.loadLeaders()
      .then(() => this.initGroups())
      .then(() => this.initLeaderNames())
      .then(() => this.loadHcCaseMasterUser());
  },

  methods: {
    loadHcCfgMeetingRoom() {
      return hcCfgMeetingRoomService
        .findById(this.hcCaseCalendarView.hcCfgMeetingRoomId)
        .then((response) => (this.hcCfgMeetingRoom = response.data));
    },

    joinRoom() {
      return hcCaseCalendarService
        .joinRoom(this.id)
        .then((response) => {
          window.open(response.data.urlWeb, "_blank");
        })
        .catch((error) => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    loadHcCaseMasterUser() {
      return hcCaseMasterUserService
        .findByHcReferenceId(this.hcCaseCalendarId)
        .then((response) => {
          this.hcCaseMasterUser = response.data;
        });
    },

    initLeaderNames() {
      let leaderNames = h.collect(this.groups, (group) => {
        switch (group.type) {
          case "item":
            return this.getLeaderName(group.data);
          case "group":
            return utils.getLabelForActorGroupFilter(group.filter);
        }
      });
      this.leaderNames = leaderNames ? leaderNames.join(", ") : null;
    },

    getLeaderName(leader) {
      // let genderName;
      // switch (leader.gender) {
      //   case constants.USERS.GENDER.FEMALE:
      //     genderName = "Chị ";
      //     break;
      //   case constants.USERS.GENDER.MALE:
      //     genderName = "Anh ";
      //     break;
      //   default:
      //     genderName = "Anh/Chị ";
      //     break;
      // }
      return `${leader.fullName}`;
    },

    initGroups() {
      this.groups = utils.groupActors(this.leaders, this.groupFilters);
    },

    loadLeaders() {
      return hcCaseCalendarUserViewService
        .findAllLanhDaoThamDu(this.caseMasterId)
        .then((response) => (this.leaders = response.data));
    },

    loadVbAttachments() {
      return attachmentService
        .findAllByHcCalendar(this.caseMasterId)
        .then((response) => (this.vbAttachments = response.data));
    },

    downloadFile(vbAttachment) {
      return downloadService
        .downloadHcCaseCalendarAttachment(
          this.hcCaseCalendarId,
          vbAttachment.id
        )
        .catch((error) => {
          this.notify(
            "Thông báo",
            errorMessageFilter({
              errorCode: "hcLichTuan.canNotDownloadAttachment",
            }),
            "error",
            2000
          );
          throw error;
        });
    },
  },
};
</script>

<style scoped>
.grid-container {
  display: grid;
  overflow: hidden;
  width: 45%;
  float: left;
  grid-template-columns: auto;
  grid-gap: 5px;
}

.grid-container:last-child {
  width: 55%;
}

.grid-container > .item {
  font-size: var(--font-small);
  padding-right: 10px;
}

.grid-container:first-child > .item {
  padding-left: 10px;
}

.grid-container > .item > .title {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
}

.grid-container > .item > .font-size__small {
  font-size: 13px;
  line-height: 20px;
}

.fc-widget-header {
  background: var(--color-dark) !important;
}

.fc-widget-header > span {
  color: white;
}

.font_blued {
  color: var(--color-blue);
}

.leftSection {
  /* width: 100%; */
}

.sharedIconDiv {
  position: absolute;
  right: 10px;
}

.sharedIconDiv i {
  font-size: x-large !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/fullCalendar-lichtuan-row.vue